import React from 'react';
import { connect } from 'react-redux'
import { Spin } from 'antd';
import {AdmsRepository} from '../../redux/AdmsActions';

/** Компонента, отображающая количество Concept-ов, у которых есть связь с http://www.w3.org/ns/adms#Asset
 * с предикатом http://www.w3.org/ns/dcat#theme. 
 * Значение количество определяется количеством http://www.w3.org/ns/adms#Asset имеющих свящь
 * 
 * В начале ConceptCount отображает загрузку, в этот момент запрашивается информация о колчестве , если 
 * значение найдено, то отображается найденноей значения, если нет, то отображается 0 */
const Loading = () => <span>(<Spin size="small" />)</span>
const Label = ({value, count}) => {
    const label = (count)?count:value;
    return (
        <span>({label})</span>
    )
}
class ConceptCount extends React.Component {
    state = {
        loaded: false,
        IRI: null,
        value: undefined
    };

    componentDidMount() {
        this.makeCount();
    }

    componentDidUpdate(prevProps, prevState) {
        this.makeCount();
    }

    static getDerivedStateFromProps(props, state) {
        if (props.count==null) {
          return {
            loaded: false
          };
        }
        return null; // Return null to indicate no change to state.
    }

    makeCount () {
        //console.log("makeCount ()", this);
        if (this.state.loaded) return;
        const {vset, IRI, lang, graph, rfilter, conditions} = this.props;
        this.props.dispatch(AdmsRepository.loadTaxonomyConceptCount(IRI, lang, graph, rfilter, conditions))
            .then ((response) =>{
                //console.log("Done!", response);
                const {count} = response;
                this.setState({loaded: true, value: count});
            })
            .catch(e => { 
                console.error("Error!", e);
            });
    }

    render(){
        //console.log(this);
        const Component = (this.state.loaded)? Label: Loading;
        return(
            <Component {...this.props} {...this.state} />
        )
    }
}

function mapStateToProps(state, props) {
    //Значения в store redux
    const {vadms, vset} = state;
    //Параметры, которые могут прийти из настроек
    const {graph, IRI, lang } = props;
    const rGraph = (graph)? graph: vset.graph;
    //Получим описание свойства. В описании должно быть IRI свойства, prefix (т.е. uri xmlns), code и строковые значения
    const statistics = (vadms && vadms.statistics)?vadms.statistics[IRI]:{};
    const count = ((typeof statistics === 'undefined') || (typeof statistics["count"] === 'undefined'))? null: statistics["count"];
    return {
        graph: rGraph,
        lang: (lang)?lang: vset.lang,
        IRI,
        rfilter: vadms.rfilter,
        conditions: vadms.conditions,
        count,
        vset
    };
}

export default connect(mapStateToProps)(ConceptCount);